import React from 'react';
import './Home.css';
import { ReactTyped } from 'react-typed';

function Home() {
  return (
    <div id="home" className="content-wrapper">
      <div className="container">
        <div className="intro-text">
          <h1>Hey there. <span className="highlight-text">It's Aboud.</span></h1>
          <h2 className="typing">
            I like to <ReactTyped
              className="typing"
              strings={["tackle challenges.","design creative solutions.", "solve problems."]}
              typeSpeed={50}
              backSpeed={30}
              loop
            />
          </h2>
          <div className="description">
          I enjoy solving problems and making life a little more efficient.</div>
        </div>
        {/* <img src="/images/emoji_guy.png" className="emoji-image" alt="emoji" /> */}
      </div>
    </div>
  );
}

export default Home;

// import React from 'react';
// import { motion } from 'framer-motion';
// import './Home.css';
// import { ReactTyped } from 'react-typed';

// function Home() {
//   return (
//     <div id="home" className="content-wrapper">
//       <div className="container">
//         <div className="intro-text">
//           {/* "Hey there." - No animation */}
//           <h1>
//             Hey there. <motion.span
//               className="highlight-text"
//               initial={{ opacity: 0, y: 50 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
//             >
//               It's Aboud.
//             </motion.span>
//           </h1>

//           {/* Typed text + Description - Show up together after "It's Aboud." */}
//           <motion.div
//             initial={{ opacity: 0, y: 50 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 1, delay: 1.5, ease: "easeOut" }}
//           >
//             <h2 className="typing">
//               I like to <ReactTyped
//                 className="typing"
//                 strings={["tackle challenges.", "design creative solutions.", "solve problems."]}
//                 typeSpeed={50}
//                 backSpeed={30}
//                 loop
//               />
//             </h2>

//             <div className="description">
//               I enjoy solving problems and making life a little more efficient.
//             </div>
//           </motion.div>
//         </div>

//         {/* Static Emoji Image */}
//         <img src="/images/emoji_guy.png" className="emoji-image" alt="emoji" />
//       </div>
//     </div>
//   );
// }

// export default Home;
